import clsx from "clsx";
import { motion } from "framer-motion";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React, { FC } from "react";

export interface MaterialsSliderImageProps {
  page: number;
  source?: IGatsbyImageData | null;
  isMobile?: boolean;
  currentSlideIndex: number;
}

export const MaterialsSliderImage: FC<MaterialsSliderImageProps> = ({
  page,
  source,
  isMobile,
  currentSlideIndex,
}) => {
  const isCurrent = currentSlideIndex === page;

  return (
    <motion.div
      key={page}
      className="absolute"
      animate={{
        opacity: isCurrent ? 1 : 0,
        zIndex: isCurrent ? 1 : 0,
        [isMobile ? "x" : "y"]: isCurrent ? 0 : `calc(100% * ${page - currentSlideIndex})`,
      }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      {source && (
        <GatsbyImage
          className={clsx(isMobile ? "max-w-full max-h-[50vh]" : "w-full px-8 lg:pr-14")}
          image={source}
          alt=""
          objectFit="contain"
          loading="eager"
        />
      )}
    </motion.div>
  );
};
